






































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component, Watch } from 'vue-property-decorator';
import { SwScrollView } from '@libs-uuif/shared/sw-scroll-view';
import { RootStoreState } from '@/store';
import { State } from 'vuex-class';
import { DashBoardStoreState } from '..';

@Component({
  components: {
    SwScrollView,
  },
})
export default class ScrollView extends SwExtendedVue {
  navBarTravelling: boolean = false;
  navBarTravelDirection: string = '';
  navBarTravelDistance: number = 200;
  overflow : string = 'none';
  scrollNav: HTMLElement | null;
  scrollNavContents: HTMLElement | null;
  leftVisibility: boolean = true;
  rightVisibility: boolean = true;
  rightDiff: Number;
  leftDiff: Number;
  containerMetrics: any;
  containerMetricsRight: any;
  containerMetricsLeft: any;
  scrollEvent: any;
  scrollRightC: any = false;
  scrollLeftC: any = false;
  timer: any = false;
  clicked: boolean = false;
  assign: boolean = false;

  @Watch('customersDetails')
  someFunction(arr: any) {
    setTimeout(() => { this.determineOverflow(); });
    arr.length === 0 ? this.assign = true : this.assign = false;
  }

  @State((state: RootStoreState) => state.DashBoardStoreModule.filteredCustomers)
  customersDetails: DashBoardStoreState['filteredCustomers'];

  myView = this.$store.getters['DashBoardStoreModule/getSwitchCss'];

  mounted() {
    this.rightDiff = 0;
    this.leftDiff = 0;
    this.scrollNav = document.getElementById('scrollNav');
    this.scrollNavContents = document.getElementById('scrollNavContents');

    this.$nextTick(() => {
      window.addEventListener('resize', this.determineOverflow);
    });

    this.determineOverflow();
    this.scrollEvent = this.scrollNav!.scrollLeft;

    this.scrollNav!.addEventListener('scroll', (e: Event) => { // tslint:disable-line
      this.determineOverflow();
    });
  }

  smoothScrollStart(direction: string): void {
    const time = 1000 / 60;
    switch (direction) {
      case 'left':
        this.timer = setInterval(() => this.scrollLeft(), time);
        break;
      case 'right':
        this.timer = setInterval(() => this.scrollRight(), time);
        break;
    }
  }

  smoothScrollStop() {
    clearInterval(this.timer);
    this.timer = false;
  }

  scrollLeft() {
    if (this.navBarTravelling && !this.scrollLeftC) {
      return;
    }
    if (this.determineOverflow() === 'left' || this.overflow === 'both') {
      const availableScrollLeft = this.scrollNav!.scrollLeft;
      if (availableScrollLeft < this.navBarTravelDistance * 2) {
        this.scrollNavContents!.style.transform = `translateX(${availableScrollLeft}px)`;
      } else {
        this.scrollNavContents!.style.transform = `translateX(${this.navBarTravelDistance}px)`;
      }
      this.scrollNavContents!.classList.remove('noTransition');
      this.navBarTravelling  = true;
      this.navBarTravelDirection = 'left';
    }
  }

  scrollRight() {
    if (this.navBarTravelling && !this.scrollRightC) {
      return;
    }
    if (this.determineOverflow() === 'right' || this.overflow === 'both') {
      const navBarRightEdge = this.scrollNavContents!.getBoundingClientRect().right;
      const navBarScrollerRightEdge = this.scrollNav!.getBoundingClientRect().right;
      const availableScrollRight = Math.floor(navBarRightEdge - navBarScrollerRightEdge);
      if (availableScrollRight < this.navBarTravelDistance * 2) {
        this.scrollNavContents!.style.transform = `translateX(-${availableScrollRight}px)`;
        this.$emit('navigationEnd', true);
      } else {
        this.scrollNavContents!.style.transform = `translateX(-${this.navBarTravelDistance}px)`;
      }
      this.scrollNavContents!.classList.remove('noTransition');
      this.navBarTravelDirection = 'right';
      this.navBarTravelling  = true;
    }
  }
  determineOverflow() {
    this.rightDiff = 0;
    this.leftDiff = 0;
    this.containerMetrics = this.scrollNav!.getBoundingClientRect();
    this.containerMetricsRight = Math.floor(this.containerMetrics.right);
    this.containerMetricsLeft = Math.floor(this.containerMetrics.left);
    const contentMetrics = this.scrollNavContents!.getBoundingClientRect();
    const contentMetricsRight = Math.floor(contentMetrics.right);
    const contentMetricsLeft = Math.floor(contentMetrics.left);
    this.overflow = 'none';
    if (this.containerMetricsLeft > contentMetricsLeft && this.containerMetricsRight < contentMetricsRight) {
      this.overflow = 'both';
    } else if (contentMetricsLeft < this.containerMetricsLeft) {
      this.overflow = 'left';
    } else if (contentMetricsRight > this.containerMetricsRight) {
      this.overflow = 'right';
    }
    this.rightDiff = contentMetricsRight - this.containerMetricsRight;
    this.leftDiff = contentMetricsLeft - this.containerMetricsLeft;

    if (this.rightDiff === 0) {
      clearInterval(this.timer);
      this.timer = false;
    }

    if (this.leftDiff === 0) {
      clearInterval(this.timer);
      this.timer = false;
    }

    return this.overflow;
  }

  transitionEnd() {
    const scrollNav = document.getElementById('scrollNav');
    const scrollNavContents = document.getElementById('scrollNavContents') ;
    const styleOfTransform = window.getComputedStyle(scrollNavContents as Element, null);
    const tr = styleOfTransform.getPropertyValue('-webkit-transform') || styleOfTransform.getPropertyValue('transform');
    const amount = Math.abs(parseInt(tr.split(',')[4], 10) || 0);
    scrollNavContents!.style.transform = 'none';
    scrollNavContents!.classList.add('noTransition');
    if (this.navBarTravelDirection === 'left') {
      scrollNav!.scrollLeft = scrollNav!.scrollLeft - amount;
    } else {
      scrollNav!.scrollLeft = scrollNav!.scrollLeft + amount;
    }
    this.navBarTravelling  = false;
    this.determineOverflow();
  }

  created() {
    this.rightDiff = 0;
    this.leftDiff = 0;
    if (this.myView) {
      if (this.customersDetails.length === 0) {
        this.assign = true;
      }
    }
  }
}
